<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="cbp-spmenu-push" :class="{ 'modal-open': isModalOpen }">
    <!-- banner -->
    <div class="banner">
      <div class="container">
        <div class="banner-info">
          <span>最新ニュース</span>
        </div>
      </div>
    </div>
    <!-- banner-bottom -->
    <section>
      <!-- 整体 -->
      <section>
        <div class="container gradient-background">
          <!-- 标签1 -->
          <section>
            <ul>
              <li
                v-for="(item, index) in zxxxList"
                :key="index"
                @click="openModal(index, item)"
              >
                <div class="row">
                  <div class="newDate">
                    <p class="date">{{ item.zDate }}:</p>
                  </div>
                  <div class="newContent">
                    <p class="description">{{ item.zTitlejp }}</p>
                  </div>
                </div>
              </li>
            </ul>
            <div v-if="isModalOpen" class="modal">
              <div class="modal-zcontent">
                <!-- 关闭按钮 -->
                <span class="xclose" @click="closeModal">&times;</span>
                <!-- 详细内容 -->
                <div v-for="(item, index) in zxxxList" :key="index">
                  <div
                    class="col-lg-12 col-xs-12"
                    v-if="index == selectedIndex"
                  >
                    <div>
                      <div class="text-container">
                        <div
                          class="col-lg-12 col-xs-12"
                          v-if="item.zImage != null && item.zChoice == 1"
                        >
                          <img
                            :src="item.zImage"
                            alt="Lazy-loaded Image"
                            class="showImg"
                          />
                          <div
                            class="imgTitle"
                            v-if="item.zImageTitlejp != null"
                          >
                            <p>{{ item.zImageTitlejp }}</p>
                          </div>
                        </div>
                        <div
                          class="titleCon col-lg-12 col-xs-12"
                          v-if="item.zTitlejp != null"
                        >
                          <h1 class="titleConh">{{ item.zTitlejp }}</h1>
                        </div>
                        <div
                          class="titlesCon col-lg-12 col-xs-12"
                          v-if="item.zTitlejps != null"
                        >
                          <p class="titlesConp">{{ item.zTitlejps }}</p>
                        </div>
                        <div
                          class="textfrom col-lg-12 col-xs-12"
                          v-if="item.zTextjpFromjp != null"
                        >
                          <p class="textfromp">{{ item.zTextjpFromjp }}</p>
                        </div>
                        <div
                          class="col-lg-12 col-xs-12"
                          v-if="item.zImage != null && item.zChoice == 2"
                        >
                          <img
                            :src="item.zImage"
                            alt="Lazy-loaded Image"
                            class="showImg"
                          />
                          <div
                            class="imgTitle"
                            v-if="item.zImageTitlejp != null"
                          >
                            <p>{{ item.zImageTitlejp }}</p>
                          </div>
                        </div>
                        <div
                          class="textCon col-lg-12 col-xs-12"
                          v-if="item.zTextjp != null"
                        >
                          <p class="textConp">{{ item.zTextjp }}</p>
                        </div>
                        <div
                          class="col-lg-12 col-xs-12"
                          v-if="item.zImage != null && item.zChoice == 3"
                        >
                          <img
                            :src="item.zImage"
                            alt="Lazy-loaded Image"
                            class="showImg"
                          />
                          <div
                            class="imgTitle"
                            v-if="item.zImageTitlejp != null"
                          >
                            <p>{{ item.zImageTitlejp }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      showPdf: false, // 控制PDF的显示状态
      isModalOpen: false, // 控制模态框的显示状态
      selectedItem: null, // 当前选中的内容
      selectedIndex: 0,
      scrollbarWidth: 0,
      bodyPaddingRight: '',
    }
  },
  methods: {
    getScrollbarWidth() {
      // 计算滚动条宽度
      return window.innerWidth - document.documentElement.clientWidth
    },

    listClick(index) {
      if (this.showList == index) {
        this.showList = -1
      } else {
        this.showList = index
      }
    },
    // 打开模态框
    openModal(index, item) {
      if (item.zShowPDF == false) {
        this.selectedIndex = index
        this.isModalOpen = true

        // 下次DOM更新后执行
        this.$nextTick(() => {
          this.scrollbarWidth = this.getScrollbarWidth()

          if (this.scrollbarWidth > 0) {
            this.bodyPaddingRight = document.body.style.paddingRight
            // 设置body的padding-right等于滚动条宽度，防止页面跳动
            document.body.style.paddingRight = this.scrollbarWidth + 'px'
          }

          document.body.classList.add('body-no-scroll')
        })
      } else {
        let open = window.open('about:blank')
        if (open === null || typeof open === 'undefined') {
          window.location.href = item.zPDF
          return
        }
        setTimeout(() => {
          open.location = item.zPDF
        }, 300)
      }
    },
    /*openModal(index) {
      
      this.selectedIndex  = index;
      this.isModalOpen  = true;
      
    },*/
    // 关闭模态框
    closeModal() {
      this.isModalOpen = false
      document.body.classList.remove('body-no-scroll')
      document.body.style.paddingRight = this.bodyPaddingRight
    },

    changeImages(item, num) {
      const targetKey = `showImage${num}`
      // 使用Vue.set 确保响应式更新
      const temp = item.showImage1 // 保存原始st1值
      this.$set(item, 'showImage1', item[targetKey]) // st1 = 目标值
      this.$set(item, targetKey, temp)
    },
  },
  mounted() {
    this.$store.dispatch('zxxxList')
  },
  computed: {
    ...mapState({
      zxxxList: (state) => state.zxxx.zxxxList,
    }),
  },
  beforeUnmount() {
    // 清理
    this.closeChildPage()
  },
}
</script>

<style scoped>
.cbp-spmenu-push {
  overflow-x: hidden;
  position: relative;
  left: 0;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.cbp-spmenu-push .banner {
  background: url(@/components/img/zxxx/1.jpg) 0px 0px no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  -ms-background-size: cover;
  height: 500px;
  position: relative;
  width: 100%;
  background-size: 100% 100%;
}

.modal-open {
  overflow-y: hidden;
  width: 100%;
}

/*-- banner-info --*/
.banner-info {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.banner-info span {
  font-size: 50px;
  color: #fff;
  padding: 0 10px;
  margin: 0 auto;
  line-height: normal;
  background: rgba(0, 0, 0, 0.6);
  font-weight: 700;
}

.container-fluid {
  margin: 60px auto;
}

.showImg {
  max-width: 80vw;
  max-height: 60vh;
}

.gradient-background {
  margin: 0 auto;
  padding: 120px 0;
  width: 70vw;
  height: 100%; /* 設置高度為視口高度 */
}

/* 模态框样式 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  border: 1px solid #000;
}

.modal-zcontent {
  position: relative;
  padding: 80px 100px 0;
  width: 100%;
  max-width: 100vw;
  height: 100%;
  text-align: center;
  overflow: auto;
}

/* 关闭按钮 */
.xclose {
  position: absolute;
  top: 20px;
  right: 15px;
  font-size: 35px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  opacity: 1;
}

.xxd {
  margin-top: 50px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 92vw;
  height: auto;
  max-height: 90%;
}

.xxp {
  padding: 5px;
}

.xxnrbor {
  padding: 0 100px;
  height: 100vh;
}

/* 系统 */
.content {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  height: 90vh;
  display: flex;
}

.content .text-container {
  width: 70vw;
  height: auto;
  margin: 0 auto;
}

.titleCon {
  margin-top: 20px;
}
.titleConh {
  white-space: pre-line;
  font-weight: bolder;
  line-height: 1.5;
  font-size: 30px;
}

.textCon {
  margin: 20px 0;
}
.textConp {
  font-size: 20px;
  line-height: 1.3;
  text-align: left;
  white-space: pre-wrap;
  color: #000;
}

.content .text-container h3 {
  padding: 10px;
  margin: 0;
  font-size: 24px;
  color: #fff;
  text-align: left;
}
.content .img-container img {
  border: 3px solid #fff;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.2);
}
.spaceCon {
  margin: 60px auto 0;
}

.gcjsImg {
  position: relative; /* 父容器設為相對定位 */
  width: 100%;
  height: 15vw; /* 按需設置高度 */
  margin: 0;
  text-align: center;
  background-color: #fff;
}
.gcjsp {
  margin: 20px 0;
}
.gcjsp p {
  width: auto;
  text-align: center;
  font-size: 22px;
  font-weight: 600;
}

.xxnrsen {
  width: 65vw;
  height: 15vh;
  margin: 20px auto 0;
}

.newDate {
  float: left;
  text-align: right;
  width: 18vw;
}
.newContent {
  float: right;
  text-align: left;
  width: 52vw;
  padding-left: 40px;
}

/* 列表样式 */
ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin-bottom: 15px;
}

/* 日期样式 */
.date {
  font-size: 24px;
  line-height: 1.5;
  margin-top: 5px;
  font-weight: bold;
}

/* 描述样式 */
.description {
  font-size: 24px;
  line-height: 1.5;
  margin-top: 5px;
  cursor: pointer;
  white-space: pre-wrap;
}

.titlesCon {
  margin-top: 5px;
}
.titlesConp {
  white-space: pre-line;
  font-weight: bold;
  line-height: 1.5;
  font-size: 28px;
}
.textfrom {
  margin-top: 20px;
  text-align: left;
}
.textfromp {
  font-size: 20px;
}
.imgTitle {
  font-size: 25px;
  margin-top: 10px;
  font-weight: bold;
}

/* 定义禁用滚动的类 */
:global(.body-no-scroll) {
  overflow: hidden !important;
  position: fixed;
  height: 100%;
}

/* 响应式调整 */
@media (max-width: 1400px) {
  .event-container {
    font-size: 0.9em;
  }
  .text {
    padding-left: 20px;
  }
  .container {
    padding: 0;
  }
  .button {
    margin: 10px 0;
    padding: 2px;
    font-size: 2em;
  }
  .gcjsImg {
    height: 25vw;
  }
  .container-fluid {
    margin: 30px auto;
  }
  .gcjsp {
    margin: 10px 0;
  }
  .gcjsp p {
    font-size: 15px;
  }
  .banner-info span {
    font-size: 30px;
  }
  .gradient-background {
    padding: 30px 0;
    background: white;
    width: 88vw;
  }
  .col-xs-6,
  .col-xs-4 {
    padding: 0 5px;
  }
  .xxd {
    margin-top: 50px;
  }
  .row {
    padding: 0;
  }
  .content .text-container p {
    padding: 0px;
    font-size: 14px;
    line-height: 1.5;
  }
  .xclose {
    top: 5px;
    right: 5px;
    font-size: 30px;
    width: 30px;
    height: 30px;
  }
  .cbp-spmenu-push .banner {
    height: 350px;
  }

  div /deep/ .el-carousel__container {
    height: 95vh;
  }
  div /deep/ .el-carousel__arrow {
    height: 40px;
    width: 40px;
    font-size: 25px;
    background-color: rgba(31, 45, 61, 0.5);
  }

  div /deep/ .el-carousel__arrow--right {
    right: 5px;
  }
  div /deep/ .el-carousel__arrow--left {
    left: 5px;
  }

  /* 指示灯 */
  div /deep/.el-carousel__indicators--horizontal {
    position: absolute;
    left: 50%;
    bottom: 10px;
    transform: translate(-50%, 0);
    text-align: center;
  }
  div /deep/.el-carousel__indicator--horizontal button {
    width: 10px;
    height: 10px;
  }
  div /deep/.el-carousel__indicator--horizontal.is-active button {
    width: 18px;
    height: 18px;
  }
  .content .text-container {
    width: 100%;
  }
  .game-menu {
    margin: 50px auto;
    padding: 0;
  }
  .menu-item {
    font-size: 17px;
  }
  .xxnrbor {
    padding: 0 5px;
  }
  .xxnrsen {
    width: 85vw;
    height: 12vh;
    margin: 10px auto 0;
  }
  .content {
    width: 100vw;
  }
  .newDate {
    width: 23vw;
  }
  .date {
    font-size: 18px;
  }
  .newContent {
    width: 65vw;
    padding-left: 10px;
  }
  .description {
    font-size: 18px;
  }
  .modal-zcontent {
    padding: 35px 10px 20px 10px;
  }
  .titleConh {
    font-size: 19px;
  }
  .textConp {
    font-size: 16px;
  }
  .col-xs-12 {
    padding-left: 5px;
    padding-right: 5px;
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .event-container {
    font-size: 0.9em;
  }
  .text {
    padding-left: 20px;
  }
  .container {
    padding: 0;
  }
  .button {
    margin: 10px 0;
    padding: 2px;
    font-size: 2em;
  }
  .gcjsImg {
    height: 25vw;
  }
  .container-fluid {
    margin: 30px auto;
  }
  .gcjsp {
    margin: 10px 0;
  }
  .gcjsp p {
    font-size: 15px;
  }
  .banner-info span {
    font-size: 27px;
  }
  .gradient-background {
    padding: 30px 0;
    background: white;
    width: 85vw;
  }
  .col-xs-6,
  .col-xs-4 {
    padding: 0 5px;
  }
  .xxd {
    margin-top: 50px;
  }
  .row {
    padding: 0;
  }
  .content .text-container p {
    padding: 0px;
    font-size: 14px;
    line-height: 1.5;
  }
  .xclose {
    top: 5px;
    right: 5px;
    font-size: 30px;
    width: 30px;
    height: 30px;
  }
  .cbp-spmenu-push .banner {
    height: 200px;
  }

  div /deep/ .el-carousel__container {
    height: 95vh;
  }
  div /deep/ .el-carousel__arrow {
    height: 40px;
    width: 40px;
    font-size: 25px;
    background-color: rgba(31, 45, 61, 0.5);
  }

  div /deep/ .el-carousel__arrow--right {
    right: 5px;
  }
  div /deep/ .el-carousel__arrow--left {
    left: 5px;
  }

  /* 指示灯 */
  div /deep/.el-carousel__indicators--horizontal {
    position: absolute;
    left: 50%;
    bottom: 10px;
    transform: translate(-50%, 0);
    text-align: center;
  }
  div /deep/.el-carousel__indicator--horizontal button {
    width: 10px;
    height: 10px;
  }
  div /deep/.el-carousel__indicator--horizontal.is-active button {
    width: 18px;
    height: 18px;
  }
  .content .text-container {
    width: 100%;
  }
  .game-menu {
    margin: 50px auto;
    padding: 0;
  }
  .menu-item {
    font-size: 17px;
  }
  .xxnrbor {
    padding: 0 5px;
  }
  .xxnrsen {
    width: 85vw;
    height: 12vh;
    margin: 10px auto 0;
  }
  .content {
    width: 100vw;
  }
  .newDate {
    width: 25vw;
  }
  .date {
    font-size: 16px;
  }
  .newContent {
    width: 65vw;
    padding-left: 10px;
  }
  .description {
    font-size: 13px;
  }
  .modal-zcontent {
    padding: 35px 10px 20px 10px;
  }
  .titleConh {
    font-size: 19px;
  }
  .textConp {
    font-size: 14px;
  }
  .col-xs-12 {
    padding-left: 5px;
    padding-right: 5px;
  }
}
@media (min-width: 2000px) {
  .banner-info span {
    font-size: 65px;
  }
  .date {
    font-size: 29px;
  }
  .description {
    font-size: 29px;
  }
  .titleConh {
    font-size: 35px;
  }
  .titlesConp {
    font-size: 33px;
  }
  .textConp {
    font-size: 25px;
  }
}
</style>
